import React from "react";
import { Errorbar } from './Errorbar';
// components
declare global {
  interface Window {
    FeatureFlags?: {
      showRoosterLookup: boolean;
    };
  }
}

export function Navbar() {
  const showRoosterLookup = window.FeatureFlags?.showRoosterLookup?? true;

  return (
    <>
      <Errorbar />
      <div className="navbar bg-base-100 shadow-sm">
        <div className="navbar-start">
          <div className="dropdown">
            <div tabIndex={0} role="button" className="btn btn-ghost lg:hidden">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"> <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /> </svg>
            </div>
            <ul
              tabIndex="-1"
              className="menu menu-sm dropdown-content bg-base-100 rounded-box z-1 mt-3 w-52 p-2 shadow">
              <li><a href="/chickens">View shared roosters</a></li>
              <li><a href="/chickens/sightings">View latest sightings</a></li>
              <li><a href="/chickens/new">Share a rooster</a></li>
              {showRoosterLookup ? <li><a href="/lookups/new">Look up a rooster</a></li> : <></>}
            </ul>
          </div>
          <a className="btn btn-ghost text-xl" href="/">Rooster Vision</a>
        </div>
        <div className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal px-1">
            <li><a href="/chickens">View shared roosters</a></li>
            <li><a href="/chickens/sightings">View latest sightings</a></li>
            <li><a href="/chickens/new">Share a rooster</a></li>
            {showRoosterLookup ? <li><a href="/lookups/new">Look up a rooster</a></li> : <></>}
          </ul>
        </div>
        <div className="navbar-end" />
      </div>
    </>
  );
}
